var React = require('react');

function IconSentEmail (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n    .st0{stroke-width:1.25;stroke-linecap:round;stroke-miterlimit:10}\n  "),React.createElement("path",{"fill":"currentColor","d":"M25.1 0c.8 0 1.4.7 1.4 1.5v8.8c0 .8-.6 1.5-1.4 1.5H12.9c-.8 0-1.4-.7-1.4-1.5V1.5c0-.8.6-1.5 1.4-1.5h12.2zm0 1.5H12.9v1.2c.7.6 1.7 1.4 3.9 3.3.5.4 1.5 1.4 2.2 1.4.7 0 1.7-1 2.1-1.4L25 2.7c.1 0 .1-1.2.1-1.2zm-12.2 8.8h12.2V4.6c-1 .8-2 1.7-3.1 2.5-.7.5-1.8 1.7-3 1.7-1.3 0-2.4-1.2-3-1.7-1-.8-2.1-1.7-3.1-2.5v5.7z","key":1}),React.createElement("path",{"fill":"currentColor","stroke":"currentColor","className":"st0","d":"M10.2 2.2H4.3M10.2 9.8H4.3M10.2 6H.8","key":2})]);
}

IconSentEmail.defaultProps = {"id":"Layer_1","viewBox":"0 0 26.5 11.7"};

module.exports = IconSentEmail;

IconSentEmail.default = IconSentEmail;
